// hooks/useFilteredAttendance.ts
import { AttendanceRecord, RootState } from "@/types";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useGetAttendenceDetailsQuery } from "@/store/attendenceApi";

export function useFilteredAttendance(
  selectedMonth?: string | undefined,
  selectedYear?: string | undefined,
) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August", 
    "September",
    "October",
    "November",
    "December",
  ];

  const { id } = useParams();
  const { user } = useSelector((state: RootState) => state.user);
  const { data: feeHistory } = useGetAttendenceDetailsQuery(id || user?._id);

  // const filteredData = useMemo(() => {
  //   return feeHistory?.filter((record: AttendanceRecord) => {
  //     const recordDate = new Date(record.date);
  //     const matchesMonth = selectedMonth
  //       ? recordDate.getMonth() === months.indexOf(selectedMonth)
  //       : true;
  //     const matchesYear = selectedYear
  //       ? recordDate.getFullYear() === parseInt(selectedYear)
  //       : true;
  //     return matchesMonth && matchesYear;
  //   });
  // }, [feeHistory, selectedMonth, selectedYear]);

  const filteredData = useMemo(() => {
    if (!feeHistory) return [];

    const result = feeHistory.filter((record: AttendanceRecord) => {
      const recordDate = new Date(record.date);

      const matchesMonth = selectedMonth
        ? recordDate.getMonth() === months.indexOf(selectedMonth)
        : true;

      const matchesYear = selectedYear
        ? recordDate.getFullYear() === parseInt(selectedYear)
        : true;

      return matchesMonth && matchesYear;
    });

    // 🔥 SORT NEW → OLD BY DATE
    // result.sort(
    //   (a: AttendanceRecord, b: AttendanceRecord) =>
    //     new Date(b.date).getTime() - new Date(a.date).getTime(),
    // );

    return result;
  }, [feeHistory, selectedMonth, selectedYear]);

  const totalDays = filteredData?.length || 0;
  const presentDays =
    filteredData?.filter((record: AttendanceRecord) => record.attendence)
      .length || 0;
  const absentDays = totalDays - presentDays;
  const attendancePercentage = totalDays ? (presentDays / totalDays) * 100 : 0;

  return {
    filteredData,
    totalDays,
    presentDays,
    absentDays,
    attendancePercentage,
    months,
  };
}
